/// <amd-module name="Wit/UI/WorkItem/Components/ReferencedArtifact/ReferencedArtifact" />
import * as React from "react";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IReferencedArtifactProps, IReferencedArtifactStatusProps, IReferencedArtifactTitleProps } from "./ReferencedArtifact.Props";

export const ReferencedArtifact: React.FC<IReferencedArtifactProps> = props => {
    return <div className="work-item-referenced-artifact flex-row flex-center">{props.children}</div>;
};

export const ReferencedArtifactTitle: React.FC<IReferencedArtifactTitleProps> = props => {
    const { icon, id, title, href } = props;

    return (
        <div className="flex-row flex-grow flex-center">
            {icon && <div className="work-item-referenced-artifact-icon flex-shrink">{icon}</div>}
            {id && <div className="work-item-referenced-artifact-id">{id}</div>}
            <div className="flex-grow font-weight-semibold font-size-m work-item-referenced-artifact-link-container">
                <FPSLink className="work-item-referenced-artifact-link text-ellipsis" href={href}>
                    {title}
                </FPSLink>
            </div>
        </div>
    );
};

export const ReferencedArtifactStatus: React.FC<IReferencedArtifactStatusProps> = props => {
    const { left, right } = props;

    return (
        <div className="flex-row flex-self-end">
            {left}
            <div className="work-item-referenced-artifact-divider" />
            {right}
        </div>
    );
};
